// extracted by mini-css-extract-plugin
module.exports = {"path":"styles_path__2G4b1","rateString":"styles_rateString__2kfGT","rateWrapper":"styles_rateWrapper__36-5d","prefix":"styles_prefix__1OpIZ"};